export const getPromotionalPrice = (
  price: number | null,
  discountValue: number,
): number | null => {
  if (price && discountValue) {
    const discountAmount = (price * discountValue) / 100;
    return parseFloat((price - discountAmount).toFixed(2));
  }
  return price;
};
